module.exports = __webpack_public_path__ + "static/media/img161.bc3d83a5.jpg";